export enum PuzzleStatus {
  APPROVED = 'approved',
  DECLINED = 'Declined',
  PENDING_UPLOAD = 'Pending upload',
  PENDING_DELETE = 'Pending delete',
}
